const mutationTypes = {
  SET_TEST_OBJECTS: 'SET_TEST_OBJECTS',
  SET_EDITED_TEST_OBJECT: 'SET_EDITED_TEST_OBJECT',
  REPLACE_TEST_OBJECT: 'REPLACE_TEST_OBJECT',
  SET_LOADING: 'SET_LOADING',
}

const actionTypes = {
  FETCH_TEST_OBJECTS: 'FETCH_TEST_OBJECTS',
  CREATE_TEST_OBJECT: 'CREATE_TEST_OBJECT',
  DELETE_TEST_OBJECT: 'DELETE_TEST_OBJECT',
  UPDATE_TEST_OBJECT: 'UPDATE_TEST_OBJECT',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/TestObjectsTypes.js